import { SortType } from '@stylehaven/components';

import { SharedLanguageService } from '@language';

import { Column } from '../../record/entities/column.entity';
import { ColumnDef } from '../../record/entities/column-definition.entity';
import { ColumnWidth } from '../../record/entities/column-width.entity';
import { DownloadRow } from '../entities/download-row.entity';
import { DownloadColumn } from '../services/downloads-column-handler.service';

export function toDownloadColumns(translate: SharedLanguageService): Column<DownloadRow>[] {
    return [
        new ColumnDef<DownloadRow>({
            key: DownloadColumn.Naam,
            label: translate.instant('downloads.columns.name'),
            width: ColumnWidth.EXTRAWIDE
        }),
        new ColumnDef<DownloadRow>({
            key: DownloadColumn.Status,
            label: translate.instant('downloads.columns.status'),
            width: ColumnWidth.NORMAL
        }),
        new ColumnDef<DownloadRow>({
            key: DownloadColumn.Downloaddatum,
            label: translate.instant('downloads.columns.download-date'),
            width: ColumnWidth.SMALL,
            sortable: true,
            sortType: SortType.DATE
        }),
        new ColumnDef<DownloadRow>({
            key: DownloadColumn.Vervaldatum,
            label: translate.instant('downloads.columns.expiry-date'),
            width: ColumnWidth.SMALL
        }),
        new ColumnDef<DownloadRow>({
            key: DownloadColumn.Fouten,
            label: translate.instant('downloads.columns.errors'),
            width: ColumnWidth.NORMAL
        }),
        new ColumnDef<DownloadRow>({
            key: DownloadColumn.Actie,
            label: translate.instant('downloads.columns.action'),
            width: ColumnWidth.EXTRASMALL
        })
    ].map(columnDefinition => ({ columnDefinition }));
}
